module.exports = __webpack_public_path__ + "img/mainmenbuttonGREEN3.6e2f08a6.png";